import React from 'react'

const FeederIcon = () => (
  <svg viewBox="0 0 22 20" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="wd-profile-page-self-home-grid-large-1_1" transform="translate(-1086.000000, -22.000000)">
        <g id="topNavBar">
          <g id="tabOptions" transform="translate(1086.000000, 20.000000)">
            <g id="feeder">
              <rect id="holder" x="0" y="0" width="22" height="22" />
              <g id="feedsIcon-Copy" transform="translate(0.500000, 2.000000)" stroke="#616161" strokeWidth="1.5">
                <rect id="feed" x="11.25" y="3.375" width="9" height="12.5" rx="1" />
                <rect id="feed" x="0.75" y="3.375" width="9" height="12.5" rx="1" />
                <rect id="feed" fill="#ffffff" x="5.125" y="0.75" width="10.75" height="17.75" rx="1" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export default FeederIcon
